// extracted by mini-css-extract-plugin
export var attachButton = "_cd-8";
export var sendButton = "_cd-2";
export var sendDisabled = "_cd-4";
export var sendEnabled = "_cd-3";
export var sendIcon = "_cd-6";
export var sendIconDisabled = "_cd-7";
export var sendStreaming = "_cd-5";
export var textarea = "_cd-1";
export var wrapper = "_cd-0";